/**
 * Created by senani on 12/20/18.
 */
import React, {Component} from 'react';
import './OrderConfirmationBottom.css';
import {FormattedMessage} from "react-intl";
import axios from "axios";
import {RESOURCE_BASE_URL, STRIPE_PUBLISHABLE_KEY} from "../../../../configuration";
import PaypalExpressBtn from 'react-paypal-express-checkout';
import {Redirect} from "react-router-dom";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {css} from 'glamor'
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";
import {center} from "glamor/utils";
import {StripeProvider} from 'react-stripe-elements';
import MyStoreCheckout from '../../Order/OrderConfirmationBottom/StripeComponents/MyStoreCheckout';
import './StripeComponents/MyCardElement.css';
import Modal from "react-bootstrap/es/Modal";


class OrderConfirmationBottom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            openStripeDialog: false,
            paymentClient: null,
            cardMessage: '',
            messageStyle: '',
            showMessageDialog: false,
            intentId: "0",
            showErrorDialog: false,
            errorRedirect : false,
            redirectOnCancelled : false,
            roc : false,
            showPaymentTimeMessageDialog : false
        };

        this.placeOrder = this.placeOrder.bind(this);
        this.openStripeDialogBox = this.openStripeDialogBox.bind(this);
        this.closeStripeDialogBox = this.closeStripeDialogBox.bind(this);
        this.openMessageDialog = this.openMessageDialog.bind(this);
        this.closeMessageDialog = this.closeMessageDialog.bind(this);
        this.closeErrorDialog = this.closeErrorDialog.bind(this);
        this.setCancelRedirect = this.setCancelRedirect.bind(this);

    }

    componentDidMount() {
        localStorage.setItem("ppe", null);

        let roc = JSON.parse(localStorage.getItem("roc"));
        localStorage.removeItem("roc");

        if(roc){
            this.setState({
                roc : true
            })

        }
        console.log("roc ===> ", roc);
    }

    setCancelRedirect = () => {
       localStorage.setItem("roc", "true"); //roc = redirect on cancelled
    };

    closeErrorDialog = () => {
        this.setState({
            showErrorDialog: false
        })
    };

    closeMessageDialog = () => {
        this.setState({
            showMessageDialog: false,
            openStripeDialog: false
        }, () => {

            if (this.state.intentId !== "0") {
                this.placeOrder(this.state.intentId, this.props.orderTotal, "CARD");
            }
        })
    };

    openMessageDialog = (cardMessage, style, intentId) => {
        this.setState({
            cardMessage: cardMessage,
            messageStyle: style,
            showMessageDialog: true,
            intentId: intentId
        });
    };

    openPaymentTimeMessageDialog = () => {
        this.setState({
            showPaymentTimeMessageDialog: true,
        });
    };

    closePaymentTimeMessageDialog = () => {
        this.setState({
            showPaymentTimeMessageDialog: false
        })
    };


    openStripeDialogBox = () => {
        this.setState({
            showPaymentTimeMessageDialog: false
        });
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        let stripeInfo = {
            amount: this.props.orderTotal,
            paymentMethod: "card",
            currency: "jpy",
            cartItemIds: this.props.cartItemIds,
            email: this.props.userDetails.email,
            username: this.props.userDetails.username
        };
        axios.post(RESOURCE_BASE_URL + 'api/payment/stripePayment', stripeInfo, axiosConfig)
            .then((res) => {

                if(res.data.paymentStatus){
                    this.setState({
                        cardMessage: '',
                        messageStyle: '',
                        openStripeDialog: true,
                        paymentClient: res.data.message.id,
                        intentId: res.data.payment_intent
                    })
                }else {
                    this.setState({
                        showErrorDialog: true
                    })
                }


            })
            .catch((err) => {
                this.setState({
                    showErrorDialog: true
                })
            });

    };

    closeStripeDialogBox = () => {
        this.setState({
            openStripeDialog: false
        })
    };

    placeOrder = (paymentId, orderTotal, paymentMethod) => {
          if (this.props.userId !== "") {
              let axiosConfig = {
                  headers: {
                      'Content-Type': 'application/json;charset=UTF-8',
                      "Access-Control-Allow-Origin": "*",
                  }
              };
              let cartInfo = {
                  userId: this.props.userId,
                  cartItemIds: this.props.cartItemIds,
                  paymentId: paymentId,
                  total: orderTotal,
                  discount: this.props.discount,
                  paymentMethod: paymentMethod
              };


              axios.post(RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/orders', cartInfo, axiosConfig)
                  .then((res) => {
                      this.props.getCartItems();
                      this.props.turnOffOverlayConfirm();
                      this.setState({redirect: true});
                  })
                  .catch((err) => {
                      console.log("[API] ERROR: ", err);
                      this.setState({errorRedirect: true});
                  });

        } else {
        }
    };

    render() {
        let env='production';
        // let env = 'sandbox';
        const client = {
            production: 'ARvCSM9bkVdr8QqFB3b0C_6hxzTE0IQHkeSZUznAzamMo-7kLJh_K_J28f1gVBAQlu6ERZn07u2ytbzK'
            // sandbox: 'AY9Nt5-QX4lDsRM25_YqIBYoe7ppT73gIud8-kyItJNxBB2zM4diw5YgoaSa5iCE1xaF4WA3JY6VnfHy',
            // our sandbox
            // sandbox: 'AZ_wazVZc1qK5JcNolpmZqSqDYaVLEYCBmx10auDAzkDhz80v60HODX9y4zQBKh-xD3Yy8cUErmT-S6f',
        };
        let currency = 'JPY';

        const onSuccess = (payment) => {
            localStorage.setItem("ppe", "PAYPAL");
// Congratulation, it came here means everything's fine!
            this.props.turnOnOverlayConfirm();
            this.placeOrder(payment.paymentID, this.props.orderTotal, "PAYPAL");
// console.log("success payment ===================================================================== ")
//             toast("支払いは成功しました。", {
//                 className: css({
//                     background: "#ffd133 !important",
//                     padding: "30px !important",
//                     color: "black !important"
//                 })
//             });
// this.setState({redirect: true});
// return <Redirect to="/order/all"/>

// You can bind the "payment" object's value to your state or props or whatever here, please see below for sample returned data
        };

        const onCancel = (data) => {
// User pressed "cancel" or close Paypal's popup!
// console.log("cancel payment ===================================================================== ")
//             toast("支払いはキャンセルされました。", {
//                 className: css({
//                     background: "#ffd133 !important",
//                     padding: "30px !important",
//                     color: "black !important",
//                     alignContent: center
//
//                 })
//             });

            this.setState({
                redirectOnCancelled : true
            })

// You can bind the "data" object's value to your state or props or whatever here, please see below for sample returned data
        };

        const onError = (err) => {
// console.log("error payment ===================================================================== ")

// The main Paypal's script cannot be loaded or somethings block the loading of that script!
            toast("支払い中にエラーが発生しました。", {
                className: css({
                    background: "#e36873 !important",
                    padding: "30px !important",
                    color: "black !important"
                })
            });
// Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
// => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
        };
        const {redirect} = this.state;

        if (redirect) {
                localStorage.setItem("stp", null);
                localStorage.removeItem("roc");
            return <Redirect to='/order/payment/success'/>
        }else if (this.state.errorRedirect){
                localStorage.setItem("ppe", "0");
                localStorage.removeItem("roc");
                return <Redirect to='/order/payment/fail'/>
        }

        if(this.state.redirectOnCancelled){
            return <Redirect to='/order/payment/cancelled'/>
        }

        if(this.state.roc){
            return <Redirect to='/order/payment/cancelled'/>
        }

        return (

            <div className="row">
                {/*<ToastContainer position={toast.POSITION.TOP_CENTER} autoClose={8000} hideProgressBar={true}/>*/}
                <div className="col-md-8">
                    {/* <div className="row">
<span className="order-total-text">
<FormattedMessage id="app.order.confirm.order.discount"
defaultMessage="Discount:"
description=""/></span>
<span className="order-total-value">¥ <NumberFormatter num = {this.props.discount}/></span>
</div>
<div className="row">
<span className="order-total-text">
<FormattedMessage id="app.order.confirm.order.total"
defaultMessage="Order Total:"
description=""/></span>
<span className="order-total-value">¥ <NumberFormatter num = {this.props.orderTotal}/></span>
</div>*/}

                </div>
                <div className="col-md-4">
                    <div className="spacer"></div>
                    <div className="spacer"></div>
                    <div className="pull-right payment-buttons-resp">
                        {/*<button className="btn btn-success" onClick={this.placeOrder}>
<FormattedMessage id="app.order.confirm.proceed.checkout"
defaultMessage="Proceed to Payment"
description=""/></button>*/}
                        {this.props.billingAddress === null || this.props.shippingAddress === null ?
                            <text className="payment-note">
                                <FormattedMessage id="app.order.confirm.order.payment-note"
                                                  defaultMessage="Please add billing and shipping address to make the payment!"
                                                  description=""/>

                            </text> :
                            <span>
<div className="paypal-btn-div" hidden={this.props.paymentByPaypal}>

    <button className="paypal-outer-btn-hide" onClick={this.setCancelRedirect}>支払いへ

   <div className="paypal-btn-float">
       <PaypalExpressBtn env={env} client={client} currency={currency} total={this.props.orderTotal}

                      onError={onError} onSuccess={onSuccess} onCancel={onCancel}
                      style={{
                          size: 'large', // tiny, small, medium
                          color: 'gold', // orange, blue, silver
                          shape: 'rect', // pill, rect
                          tagline: false,
                          height: 55,
                          label: 'paypal',
                          locale: 'ja_JP'
                      }}/>
                      </div>
                      </button>
</div>
<div hidden={!this.props.paymentByPaypal}>
    <button className="paypal-outer-btn-hide" onClick={this.setCancelRedirect}>支払いへ

   <div className="paypal-btn-float">
       <button className="btn btn-info card-payment-btn" onClick={this.openPaymentTimeMessageDialog}>カードで支払う</button>
   </div>
    </button>
</div>
</span>
                        }
                        {/*<PaypalExpressBtn client={client} currency={currency} total={this.props.orderTotal}
onError={onError} onSuccess={onSuccess} onCancel={onCancel} />*/}

                        <Modal dialogClassName="to-admin-modal card-payment-modal-resp"
                               show={this.state.openStripeDialog} onHide={this.closeStripeDialogBox}>
                            <Modal.Header closeButton>
                                <div className="title-1 color-text">
                                </div>
                            </Modal.Header>
                            <Modal.Body>
                                <div>

                                    {this.state.paymentClient !== null ?
                                        <StripeProvider apiKey={STRIPE_PUBLISHABLE_KEY}>
                                            <MyStoreCheckout paymentClient={this.state.paymentClient}
                                                             userDetails={this.props.userDetails}
                                                             openMessageDialog={this.openMessageDialog}
                                                             orderTotal={this.props.orderTotal}
                                                             userId={this.props.userId}
                                                             cartItemIds={this.props.cartItemIds}
                                                             paymentId={this.state.intentId}
                                                             discount={this.props.discount}
                                                             userData={this.props.userData}
                                                             authenticate={this.props.authenticate}
                                            />
                                        </StripeProvider> : ''
                                    }

                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                            </Modal.Footer>
                        </Modal>

                        {/*Payment Time Message Dialog ----------------*/}

                        <Modal dialogClassName="to-admin-modal" show={this.state.showPaymentTimeMessageDialog}
                               onHide={this.closePaymentTimeMessageDialog}>
                            <Modal.Header closeButton>
                                <div className="title-1 color-text">
                                    クレジットカード決済についての注意
                                </div>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="padding-right"> 支払い画面に遷移して、<span className="text-red">10分以内</span>に支払いを完了しない場合
                                    タイムアウトのため、支払いは失敗（決済失敗）となります。</div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button className="btn btn-primary col-md-2 pull-right"
                                        onClick={this.openStripeDialogBox}>
                                    OK
                                </button>
                            </Modal.Footer>
                        </Modal>

                        {/*Card Message Dialog ----------------*/}

                        <Modal dialogClassName="to-admin-modal" show={this.state.showMessageDialog}
                               onHide={this.closeMessageDialog}>
                            <Modal.Header closeButton>
                                <div className="title-1 color-text">
                                    支払い状況
                                </div>
                            </Modal.Header>
                            <Modal.Body>
                                <div className={this.state.messageStyle}>{this.state.cardMessage}</div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button className="btn btn-primary col-md-2 pull-right"
                                        onClick={this.closeMessageDialog}>
                                    閉じる
                                </button>
                            </Modal.Footer>
                        </Modal>

                        {/*Card error Message Dialog ----------------*/}

                        <Modal dialogClassName="to-admin-modal" show={this.state.showErrorDialog}
                               onHide={this.closeErrorDialog}>
                            <Modal.Header closeButton>
                                <div className="title-1 color-text">
                                    支払い状況
                                </div>
                            </Modal.Header>
                            <Modal.Body>
                                <div>現在、カードでのお支払いはできません。後でもう一度やり直してください。</div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button className="btn btn-primary col-md-2 pull-right" onClick={this.closeErrorDialog}>
                                    閉じる
                                </button>
                            </Modal.Footer>
                        </Modal>

                    </div>
                </div>
            </div>

        )
    }
}

export default OrderConfirmationBottom;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderConfirmationBottom/OrderConfirmationBottom.js